export default "__VITE_ASSET__BzGq3qAP__"